"use client";

import { cn } from "@/utils/cn";
import {
	DateInput as AriaDateInput,
	DateInputProps as AriaDateInputProps,
	DateSegment as AriaDateSegment,
	DateSegmentProps,
} from "react-aria-components";

function DateSegment({ className, ...props }: DateSegmentProps) {
	return (
		<AriaDateSegment
			className={cn(
				"p-0 m-0 bg-transparent text-sm rounded-none border-none outline-none ring-0 shadow-none",
				"focus:bg-transparent focus:border-none focus:outline-none focus:ring-0 focus:shadow-none",
				"data-[focus]:bg-transparent data-[focus]:border-none data-[focus]:outline-none data-[focus]:ring-0 data-[focus]:shadow-none",
				"data-[focus-visible]:bg-transparent data-[focus-visible]:border-none data-[focus-visible]:outline-none data-[focus-visible]:ring-0 data-[focus-visible]:shadow-none",
				"data-[placeholder]:text-muted-foreground",
				"data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed",
				"data-[invalid]:text-destructive",
				className,
			)}
			{...props}
		/>
	);
}

function DateInput({ className, children, ...props }: AriaDateInputProps) {
	return (
		<AriaDateInput className={cn("flex gap-1 items-center w-full", className)} {...props}>
			{children ?? (segment => <DateSegment segment={segment} />)}
		</AriaDateInput>
	);
}

export { DateInput, DateSegment };
